import React from "react";
import "./CheckboxVerity.css";

const CheckboxVerity = ({
    id,
    name,
    className,
    onChange,
    checked,
    required,
    disabled,
    style,
}) => {
    return (
        <input
            type={"checkbox" || "radio"}
            id={id}
            name={name}
            checked={checked}
            onChange={onChange}
            className={className}
            required={required}
            disabled={disabled}
            style={style}
        />
    );
};

export default CheckboxVerity;
